module.exports = __webpack_public_path__ + "static/media/mopping.5b642680.png";